import { Routes } from '@angular/router';
import { ContactsComponent } from './contacts/contacts.component';
import { AddContactComponent } from './contacts/add-contact/add-contact.component';
import { LoanComponent } from './banks/loans/loan.component';
import { AdminComponent } from './admin/admin.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './auth/login/login.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { authGuard } from './auth/auth.guard';
import { BankComponent } from './banks/bank.component';
import { AddBankComponent } from './banks/add-bank/add-bank.component';
import { InsuranceComponent } from './insurance/insurance.component';
import { AddInsuranceComponent } from './insurance/add-insurance/add-insurance.component';
import { InsuranceLoanComponent } from './insurance/insurance-loan/insurance-loan.component';
import { RiderComponent } from './insurance/riders/rider.component';
import { AmortizationComponent } from './banks/loans/amortization/amortization.component';
import { LoanDocumentationComponent } from './banks/loans/loan-documentation/loan-documentation.component';
import { UsersComponent } from './users/users.component';
import { AddUserComponent } from './users/add-user/add-user.component';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { 
    path: '',
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'contacts', component: ContactsComponent },
      { path: 'contacts/add', component: AddContactComponent },
      { path: 'contacts/edit', component: AddContactComponent },
      { path: 'loans/add', component: LoanComponent },
      { path: 'loans/edit', component: LoanComponent },
      { path: 'loans/amortization', component: AmortizationComponent },
      { path: 'loans/documentation', component: LoanDocumentationComponent },
      { path: 'admin', component: AdminComponent },
      { path: 'banks', component: BankComponent },
      { path: 'banks/add', component: AddBankComponent },
      { path: 'banks/edit', component: AddBankComponent },
      { path: 'insurance', component: InsuranceComponent },
      { path: 'insurance/add', component: AddInsuranceComponent },
      { path: 'insurance/edit/:id', component: AddInsuranceComponent },
      { path: 'insuranceloans/add', component: InsuranceLoanComponent },
      { path: 'insuranceloans/edit', component: InsuranceLoanComponent },
      // Deposit routes removed - now using dialog
      { path: 'riders/add', component: RiderComponent },
      { path: 'riders/edit/:id', component: RiderComponent },
      // Withdraw routes removed - now using dialog
      { path: 'users', component: UsersComponent },
      { path: 'users/add', component: AddUserComponent },
      { path: 'users/edit', component: AddUserComponent },
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
